import detectIE from 'detectie';

function supportsOneOf(): any {
  const IE = detectIE();

  if (IE) {
    // Edge is decent
    if (IE > 11) {
      return true;
    }
    // Everything else isn't
    return false;
  }
  return true;
}

export default supportsOneOf;
